module.exports = __webpack_public_path__ + "img/asus_tuf.a2857e26.jpg";